export default __webpack_public_path__ + "static/media/logo_septeo.56194552.svg";